import React from 'react';
import { MultiSelectItem } from '@/shared/components/ui/MultiSelect';
import { UserSelectorAvatar } from '@/shared/components/user-selector/UserSelectorAvatar';

interface ViewerEmployeeItemProps {
  id: string;
  fullName: string;
  imageUrl?: string;
}

export const ViewerEmployeeItem: React.FC<ViewerEmployeeItemProps> = ({
  id,
  fullName,
  imageUrl,
}) => {
  return (
    <MultiSelectItem
      key={id}
      value={id}
      badgeLabel={
        <div className="flex items-center gap-2">
          <UserSelectorAvatar
            imageUrl={imageUrl}
            fullName={fullName}
            size="sm"
          />
          <span className="text-sm">{fullName}</span>
        </div>
      }
      className="p-0 data-[selected=true]:bg-gray-50 data-[selected=true]:text-inherit cursor-pointer"
    >
      <div className="flex items-center p-3 border-b border-gray-100 last:border-b-0 hover:bg-gray-50 cursor-pointer">
        <UserSelectorAvatar
          imageUrl={imageUrl}
          fullName={fullName}
          className="me-3"
          size="md"
        />
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-900">{fullName}</p>
        </div>
      </div>
    </MultiSelectItem>
  );
};
